(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tm-old-belt-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tmObSteps) return;
    window.__tmObSteps = true;

    const ROOT = '[data-tm-ob-steps]';
    const desktop = window.matchMedia('(min-width: 750px)');
    const roots = new Set();
    let queued = false;

    const clamp01 = (n) => (n < 0 ? 0 : n > 1 ? 1 : n);
    const setFill = (step, value) => {
      const fill = step.querySelector('[data-tm-ob-fill]');
      if (fill) fill.style.setProperty('--tm-ob-p', value.toFixed(4));
    };

    const measure = (root) => {
      const steps = Array.from(root.querySelectorAll('[data-tm-ob-step]'));
      if (!steps.length) return;
      const vh = window.innerHeight || document.documentElement.clientHeight;

      if (desktop.matches) {
        // Section top travelling from 70% to 30% of the viewport drives 0 → 100% of the whole line.
        const top = root.getBoundingClientRect().top;
        const progress = clamp01((vh * 0.7 - top) / (vh * 0.4));
        const reach = progress * (steps.length - 1);
        steps.forEach((step, i) => {
          setFill(step, clamp01(reach - i));
          step.classList.toggle('is-active', progress > 0 && reach >= i - 0.02);
        });
        return;
      }

      // Mobile: the fill tip follows the middle of the screen.
      const middle = vh / 2;
      steps.forEach((step) => {
        const seg = step.querySelector('[data-tm-ob-seg]');
        if (seg) {
          const r = seg.getBoundingClientRect();
          setFill(step, r.height > 0 ? clamp01((middle - r.top) / r.height) : 0);
        }
        const num = step.querySelector('[data-tm-ob-num]');
        step.classList.toggle('is-active', !!num && num.getBoundingClientRect().top < middle + 50);
      });
    };

    const flush = () => {
      queued = false;
      roots.forEach((root) => {
        if (!root.isConnected) roots.delete(root);
        else measure(root);
      });
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(flush);
    };

    const init = (scope) => {
      const base = scope || document;
      if (base.matches && base.matches(ROOT)) roots.add(base);
      base.querySelectorAll(ROOT).forEach((root) => roots.add(root));
      schedule();
    };

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', () => {
      schedule();
      window.setTimeout(schedule, 500);
    });
    if (typeof desktop.addEventListener === 'function') desktop.addEventListener('change', schedule);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
      window.setTimeout(schedule, 500);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      roots.forEach((root) => {
        if (event.target.contains(root)) roots.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-old-belt-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tmObVideos) return;
    window.__tmObVideos = true;

    const SELECTOR = 'video[data-tm-ob-video]';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let observer = null;

    const attachSource = (video) => {
      if (!video.getAttribute('src') && video.dataset.src) video.setAttribute('src', video.dataset.src);
    };
    const start = (video) => {
      attachSource(video);
      if (reduce.matches) return;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    };
    const stop = (video) => {
      if (!video.paused) video.pause();
    };
    const getObserver = () => {
      if (observer || !('IntersectionObserver' in window)) return observer;
      observer = new IntersectionObserver(
        (entries) => entries.forEach((entry) => (entry.isIntersecting ? start(entry.target) : stop(entry.target))),
        { rootMargin: '150px 0px' }
      );
      return observer;
    };
    const calmDown = (video) => {
      video.removeAttribute('autoplay');
      video.setAttribute('preload', 'metadata');
      video.controls = true;
      attachSource(video);
      stop(video);
    };

    const init = (scope) => {
      const root = scope || document;
      root.querySelectorAll(SELECTOR).forEach((video) => {
        if (video.dataset.tmObBound) return;
        video.dataset.tmObBound = 'true';
        if (reduce.matches) {
          calmDown(video);
          return;
        }
        const io = getObserver();
        if (io) io.observe(video);
        else start(video);
      });
    };

    const onReduceChange = () => {
      if (reduce.matches) document.querySelectorAll(SELECTOR).forEach(calmDown);
    };
    if (typeof reduce.addEventListener === 'function') reduce.addEventListener('change', onReduceChange);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      if (!observer) return;
      event.target.querySelectorAll(SELECTOR).forEach((video) => observer.unobserve(video));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-old-boot-power"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('tm-boot-bars')) return;

    /* Grows the comparison-bar fills from 0 the first time they scroll into view.
       Without JS, with reduced motion or with animation off, the bars are simply shown full. */
    class TmBootBars extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.hasAttribute('data-animate') || reduce || !('IntersectionObserver' in window)) {
          this.classList.add('is-in');
          return;
        }
        this.classList.add('is-armed');
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.classList.add('is-in');
          this.observer.disconnect();
          this.observer = null;
        }, { threshold: 0.4 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.observer = null;
      }
    }

    /* Custom element: re-initialises by itself when the theme editor re-renders the section (shopify:section:load). */
    customElements.define('tm-boot-bars', TmBootBars);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-old-results"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('tm-results-rows')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Draws the rings from 0 and counts the numbers up once the rows scroll into view. */
    class TmResultsRows extends HTMLElement {
      connectedCallback() {
        if (this.dataset.animate !== 'true' || reduceMotion.matches || !('IntersectionObserver' in window)) return;
        this.numbers = Array.from(this.querySelectorAll('[data-value]'));
        this.classList.remove('is-playing');
        this.classList.add('is-armed');
        this.numbers.forEach((node) => { node.textContent = '0%'; });
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.play();
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.cancelAnimationFrame(this.frame);
      }

      play() {
        const duration = parseInt(this.dataset.duration, 10) || 650;
        const delay = parseInt(this.dataset.delay, 10) || 0;
        void this.offsetWidth;
        this.classList.add('is-playing');
        const start = performance.now() + delay;
        const tick = (now) => {
          const t = Math.min(1, Math.max(0, (now - start) / duration));
          const eased = 1 - Math.pow(1 - t, 3);
          this.numbers.forEach((node) => {
            node.textContent = `${Math.round(eased * Number(node.dataset.value))}%`;
          });
          if (t < 1) this.frame = window.requestAnimationFrame(tick);
        };
        this.frame = window.requestAnimationFrame(tick);
      }
    }

    customElements.define('tm-results-rows', TmResultsRows);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-old-review-card"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.tmOldcardHelpfulBound) return;
    window.tmOldcardHelpfulBound = true;
    /* "Was this review helpful?" – remembers the visitor's choice on the page (one of the two buttons pressed). */
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.tm-oldcard__btn');
      if (!button) return;
      const group = button.closest('[data-tm-oldcard-helpful]');
      if (!group) return;
      const turnOn = button.getAttribute('aria-pressed') !== 'true';
      group.querySelectorAll('.tm-oldcard__btn').forEach((btn) => {
        btn.setAttribute('aria-pressed', String(turnOn && btn === button));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-old-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('tm-loop-carousel')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /*
      Endless horizontal scroller. The original slides sit between N cloned sets on each side
      (N = enough sets to cover the viewport). When scrolling settles more than half a set away
      from the originals, the position is shifted by whole sets without animation, so the
      visible cards never change and the user never reaches an end.
    */
    class TmLoopCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-loop-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.querySelectorAll(':scope > [data-loop-slide]'));
        this.copies = 0;
        this.ready = false;
        this.target = null;

        this.onPrev = () => this.go(-1);
        this.onNext = () => this.go(1);
        this.onScroll = () => this.handleScroll();
        this.onBlockSelect = (event) => this.showBlock(event.target);
        this.prevBtn = this.querySelector('[data-loop-prev]');
        this.nextBtn = this.querySelector('[data-loop-next]');
        if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        if (this.slides.length < 2) return;
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.refresh());
          this.resizeObserver.observe(this.track);
        } else {
          this.onResize = () => this.refresh();
          window.addEventListener('resize', this.onResize);
          window.requestAnimationFrame(() => this.refresh());
        }
        this.setupAutoplay();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.viewObserver) this.viewObserver.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        window.clearInterval(this.timer);
        window.clearTimeout(this.settleTimer);
      }

      /* ---- geometry ---- */
      centerOf(el) {
        return el.offsetLeft + el.offsetWidth / 2 - this.track.clientWidth / 2;
      }
      get base() {
        return this.centerOf(this.slides[0]);
      }
      measure() {
        const first = this.slides[0].getBoundingClientRect().left;
        this.step = this.slides[1].getBoundingClientRect().left - first;
        const nextSet = this.slides[this.slides.length - 1].nextElementSibling;
        this.setWidth = nextSet ? nextSet.getBoundingClientRect().left - first : this.step * this.slides.length;
      }
      currentIndex() {
        const n = this.slides.length;
        const i = Math.round((this.track.scrollLeft - this.base) / this.step);
        return ((i % n) + n) % n;
      }

      /* ---- clones ---- */
      cloneSlide(slide) {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('data-loop-slide');
        clone.removeAttribute('data-shopify-editor-block');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        clone.setAttribute('data-loop-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        return clone;
      }
      build(copies) {
        this.track.querySelectorAll(':scope > [data-loop-clone]').forEach((node) => node.remove());
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        for (let c = 0; c < copies; c += 1) {
          this.slides.forEach((slide) => {
            before.appendChild(this.cloneSlide(slide));
            after.appendChild(this.cloneSlide(slide));
          });
        }
        this.track.insertBefore(before, this.slides[0]);
        this.track.appendChild(after);
        this.copies = copies;
      }

      refresh() {
        if (this.track.clientWidth === 0) return;
        const keepIndex = this.ready ? this.currentIndex() : 0;
        this.measure();
        if (!(this.step > 0)) return;
        const needed = Math.max(1, Math.ceil(this.track.clientWidth / this.setWidth));
        if (needed !== this.copies) {
          this.build(needed);
          this.measure();
        }
        this.target = null;
        this.jump(this.base + keepIndex * this.step);
        this.ready = true;
      }

      /* ---- movement ---- */
      jump(left) {
        const track = this.track;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = left;
        window.requestAnimationFrame(() => {
          track.style.scrollBehavior = '';
        });
      }
      normalize() {
        const offset = this.track.scrollLeft - this.base;
        const half = this.setWidth / 2;
        if (offset >= -half && offset < half) return;
        const shift = Math.round(offset / this.setWidth) * this.setWidth;
        this.jump(this.track.scrollLeft - shift);
      }
      handleScroll() {
        if (!this.ready) return;
        const track = this.track;
        const max = track.scrollWidth - track.clientWidth;
        window.clearTimeout(this.settleTimer);
        if (track.scrollLeft < 2 || track.scrollLeft > max - 2) {
          this.target = null;
          this.normalize();
          return;
        }
        this.settleTimer = window.setTimeout(() => {
          this.target = null;
          this.normalize();
        }, 150);
      }
      go(direction) {
        if (!this.ready) return;
        if (this.target === null) this.normalize();
        const base = this.base;
        const from = this.target !== null
          ? this.target
          : base + Math.round((this.track.scrollLeft - base) / this.step) * this.step;
        const to = from + direction * this.step;
        if (Math.abs(to - base) > this.setWidth * 0.9) return;
        this.target = to;
        this.track.scrollTo({ left: to, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      showBlock(target) {
        if (!this.ready || !target || !this.slides.includes(target)) return;
        this.target = null;
        this.jump(this.centerOf(target));
      }

      /* ---- optional autoplay ---- */
      setupAutoplay() {
        const interval = parseInt(this.dataset.interval, 10) || 5000;
        const designMode = window.Shopify && window.Shopify.designMode;
        if (this.dataset.autoplay !== 'true' || reduceMotion.matches || designMode) return;
        this.paused = false;
        this.inView = true;
        const pause = () => { this.paused = true; };
        const resume = () => { this.paused = false; };
        this.addEventListener('pointerenter', pause);
        this.addEventListener('pointerleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.track.addEventListener('touchstart', pause, { passive: true });
        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver((entries) => {
            this.inView = entries[entries.length - 1].isIntersecting;
          });
          this.viewObserver.observe(this);
        }
        this.timer = window.setInterval(() => {
          if (!this.paused && this.inView && !document.hidden) this.go(1);
        }, interval);
      }
    }

    customElements.define('tm-loop-carousel', TmLoopCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-old-roll-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('tm-roll-timeline')) return;

    /* Activation mark: a milestone ticks once its dot centre is above this share of the viewport. */
    const MARK = 0.55;

    class TmRollTimeline extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.tm-rt__item'));
        this.dots = this.items.map((item) => item.querySelector('.tm-rt__dot'));
        this.inView = false;
        this.frame = 0;

        this.onScroll = () => { if (this.inView) this.schedule(); };
        this.onMotionChange = () => this.setup();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motion.addEventListener) this.motion.addEventListener('change', this.onMotionChange);

        if ('ResizeObserver' in window) {
          this.resizer = new ResizeObserver(() => { this.measure(); this.schedule(); });
          this.resizer.observe(this);
        }
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.setup();
      }

      disconnectedCallback() {
        this.stopTracking();
        if (this.resizer) this.resizer.disconnect();
        if (this.motion && this.motion.removeEventListener) this.motion.removeEventListener('change', this.onMotionChange);
        window.removeEventListener('resize', this.onScroll);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      setup() {
        const armed = this.hasAttribute('data-animate') && !this.motion.matches && this.dots.length > 0 && 'IntersectionObserver' in window;
        this.classList.toggle('is-armed', armed);
        if (armed) this.startTracking();
        else this.stopTracking();
        this.measure();
        this.update();
      }

      startTracking() {
        if (this.observer) return;
        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries[entries.length - 1].isIntersecting;
          this.schedule();
        }, { rootMargin: '25% 0px 25% 0px' });
        this.observer.observe(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      stopTracking() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
        window.removeEventListener('scroll', this.onScroll);
      }

      /* Stretch the line from the first dot centre to the last dot centre. */
      measure() {
        if (!this.dots.length) return;
        const box = this.getBoundingClientRect();
        const first = this.dots[0].getBoundingClientRect();
        const last = this.dots[this.dots.length - 1].getBoundingClientRect();
        const top = first.top + first.height / 2 - box.top;
        const bottom = box.bottom - (last.top + last.height / 2);
        this.style.setProperty('--rt-top', `${Math.max(0, top).toFixed(1)}px`);
        this.style.setProperty('--rt-bottom', `${Math.max(0, bottom).toFixed(1)}px`);
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }

      update() {
        if (!this.classList.contains('is-armed')) {
          this.items.forEach((item) => item.classList.add('is-active'));
          this.style.removeProperty('--rt-p');
          return;
        }
        const mark = window.innerHeight * MARK;
        const centres = this.dots.map((dot) => {
          const r = dot.getBoundingClientRect();
          return r.top + r.height / 2;
        });
        const start = centres[0];
        const span = centres[centres.length - 1] - start;
        let progress = span > 0 ? (mark - start) / span : (mark >= start ? 1 : 0);
        progress = Math.min(1, Math.max(0, progress));
        this.style.setProperty('--rt-p', progress.toFixed(4));
        this.items.forEach((item, i) => item.classList.toggle('is-active', centres[i] <= mark));
      }
    }

    /* Custom element: re-initialises by itself when the theme editor re-renders the section (shopify:section:load). */
    customElements.define('tm-roll-timeline', TmRollTimeline);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-old-star-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tmOsrAutoplay) return;
    window.__tmOsrAutoplay = true;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const timers = new Map();

    const advance = (carousel) => {
      const track = carousel.querySelector('.dl-carousel__track');
      if (!track || carousel.classList.contains('is-static')) return;
      const end = track.scrollWidth - track.clientWidth - 2;
      if (track.scrollLeft >= end) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      if (typeof carousel.step === 'function') {
        carousel.step(1);
        return;
      }
      const items = track.children;
      const width = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
      track.scrollBy({ left: width, behavior: 'smooth' });
    };

    const bind = (carousel) => {
      if (timers.has(carousel) || reduce.matches) return;
      const seconds = parseFloat(carousel.dataset.tmOsrAutoplay) || 5;
      const state = { hover: false, focus: false, touched: false };
      carousel.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') state.hover = true; });
      carousel.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') state.hover = false; });
      carousel.addEventListener('focusin', () => { state.focus = true; });
      carousel.addEventListener('focusout', () => { state.focus = false; });
      carousel.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') state.touched = true; });
      const id = window.setInterval(() => {
        if (!carousel.isConnected) {
          window.clearInterval(id);
          timers.delete(carousel);
          return;
        }
        if (state.hover || state.focus || state.touched || document.hidden) return;
        advance(carousel);
      }, Math.max(1, seconds) * 1000);
      timers.set(carousel, id);
    };

    const init = (scope) => {
      const base = scope || document;
      base.querySelectorAll('[data-tm-osr-autoplay]').forEach(bind);
    };
    const release = (scope) => {
      timers.forEach((id, carousel) => {
        if (scope.contains(carousel)) {
          window.clearInterval(id);
          timers.delete(carousel);
        }
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => release(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
